import { render, staticRenderFns } from "./bill-delay.vue?vue&type=template&id=ec61710c"
import script from "./bill-delay.vue?vue&type=script&lang=js"
export * from "./bill-delay.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports